import { prop, compose } from 'ramda';

import { landing } from 'app/features/landing/selectors';

const heroBlock = compose(prop('heroBlock'), landing);
const titleKey = compose(prop('titleKey'), heroBlock);
const button = compose(prop('button'), heroBlock);
const buttonTextKey = compose(prop('textKey'), button);
const imageUrl = compose(prop('imageUrl'), heroBlock);
const imageUrl2X = compose(prop('imageUrl2X'), heroBlock);
const isPerksVisible = compose(prop('isPerksVisible'), heroBlock);
const titleColor = compose(prop('titleColor'), heroBlock);

export {
  titleKey,
  buttonTextKey,
  imageUrl,
  imageUrl2X,
  isPerksVisible,
  titleColor,
};
